/**
 * Game-specific themes for backgrounds, headers, and accents.
 * Uses subtle, UI-friendly gradients inspired by each game's aesthetic.
 */
export const GAME_THEMES = {
  1: {
    name: 'Counter-Strike 2',
    background: 'linear-gradient(180deg, rgba(18, 18, 18, 0.97) 0%, #0d0d0d 50%, #141414 100%), linear-gradient(135deg, rgba(245, 158, 11, 0.12) 0%, rgba(180, 83, 9, 0.08) 50%, transparent 100%)',
    headerBg: 'linear-gradient(90deg, rgba(245, 158, 11, 0.25) 0%, rgba(180, 83, 9, 0.15) 100%)',
    accent: '#f59e0b',
    accentMuted: 'rgba(245, 158, 11, 0.2)',
    backButton: 'rgba(245, 158, 11, 0.2)',
    backButtonHover: 'rgba(245, 158, 11, 0.35)',
    titleGradient: 'linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%)',
  },
  2: {
    name: 'Dota 2',
    background: 'linear-gradient(180deg, rgba(18, 18, 18, 0.97) 0%, #0a1628 50%, #141414 100%), linear-gradient(135deg, rgba(6, 182, 212, 0.1) 0%, rgba(8, 145, 178, 0.06) 50%, transparent 100%)',
    headerBg: 'linear-gradient(90deg, rgba(6, 182, 212, 0.2) 0%, rgba(8, 145, 178, 0.12) 100%)',
    accent: '#06b6d4',
    accentMuted: 'rgba(6, 182, 212, 0.2)',
    backButton: 'rgba(6, 182, 212, 0.2)',
    backButtonHover: 'rgba(6, 182, 212, 0.35)',
    titleGradient: 'linear-gradient(135deg, #22d3ee 0%, #06b6d4 100%)',
  },
  3: {
    name: 'League of Legends',
    background: 'linear-gradient(180deg, rgba(18, 18, 18, 0.97) 0%, #0f172a 50%, #141414 100%), linear-gradient(135deg, rgba(202, 138, 4, 0.1) 0%, rgba(161, 98, 7, 0.06) 50%, transparent 100%)',
    headerBg: 'linear-gradient(90deg, rgba(202, 138, 4, 0.22) 0%, rgba(161, 98, 7, 0.12) 100%)',
    accent: '#ca8a04',
    accentMuted: 'rgba(202, 138, 4, 0.2)',
    backButton: 'rgba(202, 138, 4, 0.2)',
    backButtonHover: 'rgba(202, 138, 4, 0.35)',
    titleGradient: 'linear-gradient(135deg, #facc15 0%, #ca8a04 100%)',
  },
  4: {
    name: 'Rocket League',
    background: 'linear-gradient(180deg, rgba(18, 18, 18, 0.97) 0%, #0c1e2e 50%, #141414 100%), linear-gradient(135deg, rgba(59, 130, 246, 0.1) 0%, rgba(249, 115, 22, 0.06) 50%, transparent 100%)',
    headerBg: 'linear-gradient(90deg, rgba(59, 130, 246, 0.2) 0%, rgba(249, 115, 22, 0.15) 100%)',
    accent: '#3b82f6',
    accentMuted: 'rgba(59, 130, 246, 0.2)',
    backButton: 'rgba(59, 130, 246, 0.2)',
    backButtonHover: 'rgba(59, 130, 246, 0.35)',
    titleGradient: 'linear-gradient(135deg, #60a5fa 0%, #3b82f6 100%)',
  },
};

export function getGameTheme(gameId) {
  return GAME_THEMES[gameId] || {
    name: 'Game',
    background: '#141414',
    headerBg: 'rgba(255, 255, 255, 0.05)',
    accent: '#e50914',
    accentMuted: 'rgba(229, 9, 20, 0.2)',
    backButton: 'rgba(255, 255, 255, 0.1)',
    backButtonHover: 'rgba(255, 255, 255, 0.2)',
    titleGradient: 'linear-gradient(135deg, #ffffff 0%, #e0e0e0 100%)',
  };
}
